import { DebugTranslations as View } from "@/components.debug/debug-translations";
export const DebugTranslations = {
	path:"/debug/translations",
	name:"Debug.Translations",
	component:View,
	meta:{
		title:"Translations",
		public:true,
		navHidden:true,
	}
};